import { render, staticRenderFns } from "./searchBar.vue?vue&type=template&id=47204bf8&"
import script from "./searchBar.vue?vue&type=script&lang=ts&"
export * from "./searchBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports